<template>
  <div class="GlobalFormDemo">
    <GlobalForm
      :init-data="initData"
      :form-item-list="formItemList"
      :inline="true"
      :labelWidth="90"
      round
      :needBtnLoading="true"
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
    <el-form-item
        label="商户类型"
        slot="merchantType"
        style="margin:0"
        label-width="80px"
      >
        <el-select
          @change="changeMerchantType"
          v-model="merchantType"
          placeholder="请选择"
          filterable
          clearable
        >
          <el-option
            v-for="(item, index) in merchantTypeData"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
     <el-form-item
        label="上账商户"
        slot="enterpriseId"
        style="margin:0"
        label-width="80px"
      >
        <el-select
         :disabled="!merchantType"
          v-model="enterpriseId"
          :placeholder="!merchantType?'请先选择商户类型':'请选择'"
          filterable
          clearable
        >
          <el-option
            v-for="(item, index) in InquirySelectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    <el-form-item class="el_from" label="信息获取时间" slot="infoTime" label-width="100px">
        <el-date-picker v-model="entryTime" type="daterange" start-placeholder="开始日期" range-separator="~"
          end-placeholder="结束日期" clearable :default-time="['00:00:00', '23:59:59']" :picker-options="pickerOptions1">
        </el-date-picker>
      </el-form-item>
    </GlobalForm>
  </div>
</template>

<script>
import moment from 'moment'

import _api from "@/utils/request";
export default {
  name: "Form",
  props: {},
  data() {
    return {
      enterpriseId:'',
      InquirySelectList:[],
      merchantType:"",
      merchantTypeData:[ {
              value: 'merchant',
              label: '回收商',
            },
            {
              value: 'company',
              label: '门店商',
            },],
      initData: {
        tradeTime: [
          moment()
            .day(moment().day()-6)
            .format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59"),
        ],
        infoTime: [
      ],
      },
      formItemList: [
      {
          key: "tradeTime",
          type: "pickerOptions",
          labelName: "交易时间",
          placeholder: "请选择交易时间",
          valueFormat: "timestamp",
          clearable: true,
          pickerOptions: {
            onPick: ({ maxDate, minDate }) => {
              if (minDate && this.pickerMinDate) {
                this.pickerMinDate = null;
              } else if (minDate) {
                this.pickerMinDate = minDate.getTime();
              }
            },
            disabledDate: (time) => {
              if (this.pickerMinDate) {
                return (
                  time.getTime() > this.pickerMinDate + this.day31 ||
                  time.getTime() < this.pickerMinDate - this.day31
                );
              }
              return false;
            },
          },
        },
        {slotName:"infoTime"},
        {
          key: "transferNo",
          type: "input",
          labelName: "交易流水号",
          placeholder: "请输入交易流水号",
        },
        {
          key: "relationNo",
          type: "input",
          labelName: "付款姓名",
          placeholder: "请输入付款姓名",
        },
        {
          key: "staffName",
          type: "input",
          labelName: "付款账号",
          placeholder: "请输入付款账",
        },
        {
          key: "staffPhone",
          type: "input",
          labelName: "收款账号",
          placeholder: "请输入收款账号",
        },
        {
          key: "companyName",
          type: "input",
          labelName: "收款银行",
          placeholder: "请输入收款银行",
        },
        {
          key: 'staffRole',
          type: 'select',
          labelName: '交易信息来源',
          placeholder: '请选择',
          lableWidth:"300",
          option: [
            {
              value: '00',
              label: '主动查询',
            },
            {
              value: '01',
              label: '微众通知',
            },
          ],
        },
        {slotName:'merchantType'},
        {slotName:'enterpriseId'},
        {
          key: 'accountType',
          type: 'select',
          labelName: '上账方式',
          placeholder: '请选择',
          lableWidth:"300",
          option: [
            {
              value: '00',
              label: '系统自动上账',
            },
            {
              value: '01',
              label: '人工确认上账',
            },
          ],
        },
      ],
      pickerMinDate: null,
      pickerMinDate1: null,
      day31: 30 * 24 * 3600 * 1000,
      myday31: 30 * 24 * 3600 * 1000,
      entryTime:"",
      pickerOptions1: {
            onPick: ({ maxDate, minDate }) => {
              if (minDate && this.pickerMinDate1) {
                this.pickerMinDate1 = null;
              } else if (minDate) {
                this.pickerMinDate1 = minDate.getTime();
              }
            },
            disabledDate: (time) => {
              if (this.pickerMinDate1) {
                return (
                  time.getTime() > this.pickerMinDate1 + this.myday31 ||
                  time.getTime() < this.pickerMinDate1 - this.myday31
                );
              }
              return false;
            },
          },
    };
  },
  created() {
    this.handleConfirm(this.initData)
  },
  watch:{
  },
  methods: {
    changeMerchantType(val){
      console.log(val);
      this.enterpriseId = ""
      if(val){
        if(val=='merchant'){
             this.getMerchantSelect()
        }else{
            this.getCompanySelect()
        }
      }else{
        this.InquirySelectList=[]
      }
    },
     // 回收商家下拉
     getMerchantSelect(){
      _api.listSimpleMerchantView({pageNum: 1, pageSize: 9999}).then(res => {
        this.InquirySelectList = res.data.map(item=>{
          return {
            id:item.merchantId,
            name:item.merchantName
          }
        })
      })
    },
    //获取门店商家下拉
    getCompanySelect() {
      _api.getSelectList().then(res => {
        this.InquirySelectList = res.data
      })
    },  
    handleConfirm(data,cd) {
      console.log("提交了form", data);
      let SeachParams = {};
      if (data) {
        SeachParams = {
          transferNo: data.transferNo,//交易流水号
          relationNo: data.relationNo,//付款姓名
          staffName: data.staffName,//付款账号
          staffRole: data.staffRole,//交易信息来源
          bankAccount: data.staffPhone,//收款账号
          bankName: data.companyName,//收款银行
          startTime: data.tradeTime ? moment(data.tradeTime[0]).format("x") : "",//交易时间开始
          endTime: data.tradeTime ? moment(data.tradeTime[1]).format("x") : "",//交易时间结束
          startTimeInfo: this.entryTime ? moment(this.entryTime[0]).format("x") : "",//信息获取时间开始
          endTimeInfo: this.entryTime ? moment(this.entryTime[1]).format("x") : "",//信息获取时间结束
          pageNum: 1,
          pageSize: 10,
          merchantType:this.merchantType,//商户选择
          enterpriseId:this.enterpriseId,//上账商户
          accountType:data.accountType,//上账方式
        };
      }
      SeachParams. disuseLoding= () => {
          if(typeof cd ==='function'){
             cd();
          }
        },

      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
}



</style>
